import { getAuthState } from "../../assets/scripts/login-util";
import { axiosGet, axiosPost, axiosDelete, axiosPatch } from "./axiosFunctions";

const getMatchPlaytMasterAllUrl         = '/api/admin/matchplay/getMatchPlayMasterAll';
const getMasterPageDataAllUrl           = '/api/admin/matchplay/getMasterPageData';
const getMatchPlayByIDUrl               = (matchplayId) => `/api/admin/matchplay/getMatchPlayByID/${matchplayId}`;
const postMatchPlayUrl                  = '/api/admin/matchplay/postMatchPlay';
const deleteMatchPlayUrl                = (id, pswd) => `/api/admin/matchplay/deleteMatchPlay/${id}/${pswd}`;
const updateMatchPlayPublishUrl         = '/api/admin/matchplay/updateMatchPlayPublish';
const getMatchPlayDataUrl               = '/api/admin/matchplay/getMatchPlayData';
const deleteMatchPlayRegisterUrl        = (registerId, type) => `/api/admin/matchplay/deleteMatchPlayRegistration/${registerId}/${type}`;
const getRegistrationDataUrl            = '/api/admin/matchplay/getRegistrationData';
const postMatchPlayRegisterUrl          = '/api/admin/matchplay/postMatchPlayRegistration';
const getMatchPlayRoundUrl              = (matchPlayId) => `/api/admin/matchplay/getMatchPlayRound/${matchPlayId}`;
const postMatchPlayRoundUrl             = '/api/admin/matchplay/postMatchPlayRound';
//  draw
const addMatchPlayPlayerUrl             = '/api/admin/matchplay/addMatchPlayPlayer';
const addMatchPlayPlayerVsUrl           = '/api/admin/matchplay/addMatchPlayPlayerVs';
const deleteMatchPlayPlayersUrl         = (roundId) => `/api/admin/matchplay/deleteMatchPlayPlayers/${roundId}`;
const deleteMatchPlayPlayerVsUrl        = (roundId) => `/api/admin/matchplay/deleteMatchPlayPlayerVs/${roundId}`;
const getMatchPlayPlayerAllUrl          = '/api/admin/matchplay/fetchMatchPlayPlayerAll';
const getMatchPlayPlayerVsAllUrl        = '/api/admin/matchplay/fetchMatchPlayPlayerVsAll';
const getMatchPlayPlayerVsByRoundUrl    = (roundId) => `/api/admin/matchplay/getMatchPlayPlayerVsByRoundID/${roundId}`;
const getMatchPlayDrawUrl               = (matchPlayId) => `/api/admin/matchplay/getMatchPlayDraw/${matchPlayId}`;
const postMatchPlayDrawUrl              = '/api/admin/matchplay/postMatchPlayDraw';
const refreshMatchPlayHandicapUrl       = (matchPlayID, round) => `/api/admin/matchplay/refreshHandicap/${matchPlayID}/${round}`;
// scorecard
const getMatchPlayScorecardUrl          = (matchPlayId) => `/api/admin/matchplay/getMatchPlayScorecard/${matchPlayId}`;
const getMatchPlayWinnerUrl             = (matchPlayId) => `/api/admin/matchplay/getMatchPlayWinner/${matchPlayId}`;
const postWalkoverUrl                   = `/api/admin/matchplay/postWalkover`;
const postScoreCardUrl                  = `/api/admin/matchplay/postScore`;
const verifyScoreUrl                    = `/api/admin/matchplay/verifyscore`;
const emailMatchPlayWinnerUrl           = `/api/admin/matchplay/emailMatchPlayWinner`;


export const getMatchPlayMasterAll = async() => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( getMatchPlaytMasterAllUrl, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const getMasterPageData = async() => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( getMasterPageDataAllUrl, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const getMatchPlayByID = async(matchplayId) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( 
        getMatchPlayByIDUrl(matchplayId), 
        { headers: { auth_token: `bearer ${token}` } } 
    );
    return response;
}

export const getMatchPlayData = async(matchplayId) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( `${getMatchPlayDataUrl}/${matchplayId}`, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const postMatchPlayData = async (matchPlayMaster) => {
    const token = getAuthState('token');
    if (!token) setTimeout(()=> { return }, 2000);
    
    const response = await axiosPost(
        postMatchPlayUrl,
      { matchPlayMaster},
      { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const deleteMatchPlayData = async (matchPlayId, password) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosDelete(
        deleteMatchPlayUrl(matchPlayId, password),
      { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};


export const updateMatchPlayPublish= async (matchPlayId, isPublish) => { 

    const token = getAuthState('token');
    if (!token) setTimeout(()=> { return }, 2000);
    
    const response = await axiosPost(
        updateMatchPlayPublishUrl, { matchPlayId, isPublish },
      { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const deleteMatchPlayRegister = async (registerId, type) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosDelete(
        deleteMatchPlayRegisterUrl(registerId, type),
        { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const getRegistrationData = async(matchPlayId) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( `${getRegistrationDataUrl}/${matchPlayId}`, { headers: { auth_token: `bearer ${token}` } } );

    return response;
}

export const postMatchPlayRegistration = async (matchPlayRegister) => {
    const token = getAuthState('token');
    if (!token) setTimeout(()=> { return }, 2000);
    
    const response = await axiosPost(
        postMatchPlayRegisterUrl, { matchPlayRegister},
      { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const getMatchPlayRound = async (matchPlayId) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
     const response = await axiosGet( getMatchPlayRoundUrl(matchPlayId), 
        { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const postMatchPlayRound = async (matchPlayData) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost(postMatchPlayRoundUrl, 
        matchPlayData,
        { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

// draw api's to be added here

export const addMatchPlayPlayer = async () => {
    const token = getAuthState('token');
    if (!token) setTimeout(()=> { return }, 2000);
    
    const response = await axiosPost(
        addMatchPlayPlayerUrl,
      
      { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const addMatchPlayPlayerVs = async () => {
    const token = getAuthState('token');
    if (!token) setTimeout(()=> { return }, 2000);
    
    const response = await axiosPost(
        addMatchPlayPlayerVsUrl,
      
      { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const deleteMatchPlayPlayerVS = async (roundId) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosDelete(
        deleteMatchPlayPlayerVsUrl(roundId),
        { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const deleteMatchPlayPlayers = async (roundId) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosDelete(
        deleteMatchPlayPlayersUrl(roundId),
        { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const getMatchPlayPlayerAll = async() => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( getMatchPlayPlayerAllUrl, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const getMatchPlayPlayerVsAll = async() => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( getMatchPlayPlayerVsAllUrl, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const getMatchPlayPlayerVsByRoundID = async (roundId) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
     const response = await axiosGet( getMatchPlayPlayerVsByRoundUrl(roundId), 
        { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const getMatchPlayRoundByMatchPlayID = async (matchPlayId) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
     const response = await axiosGet( getMatchPlayRoundUrl(matchPlayId), 
        { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const getMatchPlayRoundData = async(matchPlayId) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet(`${getMatchPlayRoundUrl}/${matchPlayId}`, { headers: { auth_token: `bearer ${token}` } } );
    
    return response;
}

// draw api's to be added here
export const getMatchPlayDraw = async (matchPlayId) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet(`${getMatchPlayDrawUrl(matchPlayId)}`, { headers: { auth_token: `bearer ${token}` } } );
    
    return response;
}

export const postMatchPlayDraw = async(matchPlayDraw) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost(`${postMatchPlayDrawUrl}`, matchPlayDraw, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const refreshMatchPlayHandicap = async({matchPlayID, round}) => {
    console.log("Handicap111 refreshed: ");
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet(`${refreshMatchPlayHandicapUrl(matchPlayID, round)}` ,{headers: { auth_token: `bearer ${token}` } } );
    console.log("Handicap refreshed: ", response);
    return response;
}

// scorecard

export const getMatchPlayScorecard = async (matchPlayId) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000); 
    const response = await axiosGet(`${getMatchPlayScorecardUrl(matchPlayId)}`, { headers: { auth_token: `bearer ${token}` } });
    return response;
}

export const walkoverChangeAPI = async (winnerData) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    const response = await axiosPost(
        postWalkoverUrl, { winner: winnerData },
        { headers: { auth_token: `bearer ${token}` } }    
    );
    return response;
}

export const postScoreCard = async ({matchPlayWinner, matchPlayWinnerHole}) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    const response = await axiosPost(
        postScoreCardUrl, {matchPlayWinner, matchPlayWinnerHole},
        { headers: { auth_token: `bearer ${token}` } }    
    );
    return response;
}

export const getMatchPlayWinner = async (matchPlayId) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000); 
    const response = await axiosGet(`${getMatchPlayWinnerUrl(matchPlayId)}`, { headers: { auth_token: `bearer ${token}` } });
    return response;
}

export const verifyScore = async (matchPlayPlayerVsID) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    const response = await axiosPost(
        verifyScoreUrl, { matchPlayPlayerVsID }, { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
}

export const emailMatchPlayWinner = async (finalWinner) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    const response = await axiosPost(
        emailMatchPlayWinnerUrl, {finalWinner}, { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
}